export default __webpack_public_path__ + "static/media/bg8.0be0486e.png";